import { MenuItem, Select, FormControl, InputLabel, FormHelperText, OutlinedInput } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import React from 'react';

const SelectWrapper = ({
    name,
    options,
    label,
    noneRequired,
    ...otherProps
}) => {
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(name);
    const handleChange = evt => {
        const { value } = evt.target;
        setFieldValue(name, value);
    };

    const configSelect = {
        ...field,
        ...otherProps,
        onChange: handleChange,
        variant: 'outlined'
    };

    const sortedOptions = Object.entries(options)
        .map(([id, value]) => ({ id: Number(id), value}))
        .sort((a, b) => a.value.localeCompare(b.value));

    return (
        <FormControl fullWidth variant="outlined" size="small" error={meta && meta.touched && meta.error}>
            {label && <InputLabel id="select-label">{label}</InputLabel>}
            <Select labelId="select-label" input={<OutlinedInput label={label} />} {...configSelect}>
            { noneRequired && (<MenuItem key="" value={null}>None</MenuItem>)}
                {sortedOptions.map((option) => (
                    <MenuItem key={option.id} value={Number(option.id)}>
                        {option.value}
                    </MenuItem>
                ))}
            </Select>
            {meta && meta.touched && meta.error && (
                <FormHelperText>{meta.error}</FormHelperText>
            )}
        </FormControl>
    );
}

export default SelectWrapper;